import React, { lazy } from 'react';
import { useReveal } from '../lib/useReveal';
const PREVIEWS = [{
  image: 'https://cdn.magicpatterns.com/uploads/knyG1FUxYywPeXfortkjob/Screenshot_2026-02-13_110339.png',
  label: 'Tomo 1 — El origen del Reiki',
  rotation: '-1deg'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/4e6fsyuELv2iDdy33y2qYL/Screenshot_2026-02-13_110621.png',
  label: 'Bono — Guía de los 7 Chakras',
  rotation: '1deg'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/gsZhMfyPMptc8NCZiSd4ic/Screenshot_2026-02-13_110736.png',
  label: 'Bono — Guía de los 7 Chakras',
  rotation: '-0.5deg'
}];
export function PreviewSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section className="bg-[#f0eaf7] py-20 md:py-28 px-4 overflow-hidden" data-id="element-152">
      <div className="container mx-auto max-w-6xl" data-id="element-153">
        <div ref={ref1} className={`reveal text-center mb-16 ${vis1 ? 'is-visible' : ''}`} data-id="element-154">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900 mb-4 leading-tight" data-id="element-155">
            📖 Mirá lo que vas a encontrar adentro
          </h2>
          <p className="text-lg text-gray-600 font-medium" data-id="element-156">
            Páginas reales del MegaPack Reiki
          </p>
        </div>

        <div ref={ref2} className={`reveal grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 ${vis2 ? 'is-visible' : ''}`} data-id="element-157">
          {PREVIEWS.map((item, idx) => <div key={idx} className="group" style={{
          transitionDelay: `${idx * 150}ms`
        }} data-id="element-158">
              <div className="relative bg-[#faf5ef] p-2 md:p-3 rounded-xl shadow-[0_10px_40px_-10px_rgba(0,0,0,0.1)] border border-white/50 transition-all duration-500 hover:scale-[1.02] hover:shadow-[0_20px_50px_-10px_rgba(0,0,0,0.15)] hover:!rotate-0 hover:z-10" style={{
            transform: vis2 ? `rotate(${item.rotation})` : 'rotate(0deg)',
            transition: 'transform 0.8s ease-out, box-shadow 0.5s ease'
          }} data-id="element-159">
                <div className="overflow-hidden rounded-lg bg-white" data-id="element-160">
                  <img src={item.image} alt={item.label} className="w-full h-auto object-cover" loading="lazy" data-id="element-161" />
                </div>
              </div>
              <p className="text-center mt-4 text-sm font-bold text-gray-500 uppercase tracking-wider" data-id="element-162">
                {item.label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}